export default __webpack_public_path__ + "static/media/wink-trans.78857ba6.svg";